export default "__VITE_ASSET__DJ0ZjmU7__"